import { CheckedAddress } from '@/domain/types/CheckedAddress'
import { mainnet } from 'viem/chains'

import { zeroAddress, type Chain } from 'viem'
import { isTestnet } from '../consts'

export const hyperTestnet = {
  id: 998,
  name: 'Hyperliquid EVM Testnet',
  nativeCurrency: { name: 'Hype', symbol: 'HYPE', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.hyperliquid-testnet.xyz/evm'] },
  },
  blockExplorers: {
    default: { name: 'Purrsec', url: 'https://testnet.purrsec.com' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
  },
} as const satisfies Chain

export const hyperTestnetDynamic = {
  blockExplorerUrls: [hyperTestnet.blockExplorers.default.url],
  chainId: hyperTestnet.id,
  networkId: hyperTestnet.id,
  chainName: hyperTestnet.name,
  name: hyperTestnet.name,
  vanityName: 'HyperEVM Testnet',
  iconUrls: ['/hyper-evm-logo.png'],
  nativeCurrency: {
    ...hyperTestnet.nativeCurrency,
    iconUrl: '/hyper-evm-logo.png',
  },
  rpcUrls: [hyperTestnet.rpcUrls.default.http[0]],
}

export const hyperEVM = {
  id: 999,
  name: 'HyperEVM',
  nativeCurrency: { name: 'Hype', symbol: 'HYPE', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.hyperliquid.xyz/evm'] },
  },
  blockExplorers: {
    default: { name: 'Purrsec', url: 'https://www.hyperscan.com' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
    repayHelper: {
      address: '0xcD25A8404f136E762c5c18285223815BC3407f24',
    },
  },
} as const satisfies Chain

export const hyperEVMDynamic = {
  blockExplorerUrls: [hyperEVM.blockExplorers.default.url],
  chainId: hyperEVM.id,
  networkId: hyperEVM.id,
  chainName: hyperEVM.name,
  name: hyperEVM.name,
  vanityName: hyperEVM.name,
  iconUrls: ['/hyper-evm-logo.png'],
  nativeCurrency: {
    ...hyperEVM.nativeCurrency,
    iconUrl: '/hyper-evm-logo.png',
  },
  rpcUrls: [hyperEVM.rpcUrls.default.http[0]],
}

export const SUPPORTED_CHAINS = isTestnet ? [hyperTestnet] : [hyperEVM]
export const SUPPORTED_CHAINS_DYNAMIC = isTestnet ? [hyperTestnetDynamic] : [hyperEVMDynamic]
export const SUPPORTED_CHAIN_IDS = SUPPORTED_CHAINS.map((chain) => chain.id)

export const susdsAddresses = {
  [mainnet.id]: CheckedAddress('0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD'),
} as const

export const isolatedRegistryAddress = {
  [hyperEVM.id]: CheckedAddress('0x5aB54F5Ca61ab60E81079c95280AF1Ee864EA3e7'),
  [hyperTestnet.id]: CheckedAddress(zeroAddress),
} as const
